import React from 'react'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import {useHistory} from 'react-router-dom'

import mastheadLogo from './img/masthead-logo.png'
import appIcon from './img/icon.png'
import planet3 from './img/planet-3.png'
import planet2 from './img/planet-2.png'
// import video from './video/video.mp4'
import sunrise from './img/sunrise.png'
import Demo from '../demo/demo'
import {destroyGame} from '../launch/launch'
import './landing.css'

const Landing = () => {
    const history = useHistory()

    return (
        <>
            <Container maxWidth={false}>
                <Box
                    className="masthead"
                    sx={{
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: 'center',
                    }}
                >
                    <img
                        className="masthead-logo"
                        src={mastheadLogo}
                        alt="logo"
                        onLoad={(ev) => {
                            ev.target.classList.add('masthead-logo--loaded')
                        }}
                    />
                </Box>
            </Container>

            <Container maxWidth="xl">
                <Box
                    sx={{
                        pt: {xs: 2, md: 15},
                        pb: {xs: 2, md: 20},
                        position: 'relative',
                        overflow: 'hidden',
                    }}
                >
                    <Box
                        sx={{
                            position: 'relative',
                            zIndex: 1,
                        }}
                    >
                        <Box
                            sx={{
                                p: 4,
                                pt: 8,
                            }}
                        >
                            <Typography
                                component="h1"
                                variant="h3"
                                align="center"
                                color="text.primary"
                                sx={{
                                    fontSize: {xs: '2rem', md: '3rem'},
                                    mb: 3,
                                }}
                            >
                                Greetings Admiral, Your Fleet Awaits...
                            </Typography>
                            <Stack
                                sx={{pt: 4}}
                                direction={{xs: 'column', sm: 'row'}}
                                spacing={2}
                                justifyContent="center"
                            >
                                <Button
                                    size="large"
                                    variant="contained-1"
                                    onClick={() => {
                                        destroyGame()
                                        history.push('starbase')
                                    }}
                                    className="cta"
                                    sx={{
                                        padding: {
                                            xs: '15px 50px',
                                            md: '15px 100px',
                                        },
                                    }}
                                >
                                    Launch
                                </Button>
                            </Stack>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            position: 'absolute',
                            zIndex: 0,
                            // top: {xs: '15%', sm: 0, md: '-5%', lg: '-15%'},
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0,
                            overflow: 'hidden',
                        }}
                    >
                        <Box
                            className="gr-left"
                            display={{xs: 'none', md: 'block'}}
                        />

                        <Box
                            sx={{
                                position: 'absolute',
                                zIndex: 2,
                                background: '#000',
                                opacity: 0.6,
                                width: '100%',
                                height: '100%',
                            }}
                        />
                        <Demo />
                        {/* <video autoPlay muted loop className="video">
                            <source src={video} type="video/mp4" />
                        </video> */}
                        <Box
                            className="gr-right"
                            display={{xs: 'none', md: 'block'}}
                        />
                    </Box>
                </Box>
            </Container>

            <Container maxWidth={false} className="bg-1">
                <Box maxWidth="sm" sx={{m: 'auto', p: 8}}>
                    <Box
                        sx={{
                            mb: 4,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <img
                            src={appIcon}
                            className="section-icon"
                            alt="app icon"
                        />
                    </Box>

                    <Typography
                        component="h2"
                        variant="h4"
                        align="center"
                        color="text.primary"
                    >
                        What is Galactic Endeavor?
                    </Typography>

                    <Typography variant="h6" align="center" sx={{mt: 5}}>
                        <strong>Galactic Endeavor</strong> is a space-based RTS
                        where you must lead your faction to victory by exploring
                        and colonizing the star system.
                    </Typography>
                </Box>
            </Container>

            <Divider />

            <Container maxWidth={false} align="center" className="bg-3">
                <Box maxWidth="md" sx={{margin: 'auto', p: 10}}>
                    <Box
                        sx={{
                            mb: 4,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <img
                            src={planet2}
                            className="section-icon"
                            alt="planet"
                        />
                    </Box>
                    <Typography
                        component="h4"
                        variant="h4"
                        color="text.primary"
                        gutterBottom
                        sx={{
                            mb: 8,
                        }}
                    >
                        Current Features
                    </Typography>

                    <Grid container spacing={5} wrap="wrap" sx={{mb: 5}}>
                        <Grid item xs={12} md={6}>
                            <Typography component="h5" variant="h5">
                                Explore new worlds
                            </Typography>
                            <Typography component="p">
                                Discover new planets, colonize them, and extract
                                resources
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography component="h5" variant="h5">
                                Resource Management
                            </Typography>
                            <Typography component="p">
                                Gather and balance resources to fuel your fleet
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography component="h5" variant="h5">
                                Alien Artifacts
                            </Typography>
                            <Typography component="p">
                                Discover alien artifacts scattered amongst the
                                stars
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography component="h5" variant="h5">
                                Enemy Faction
                            </Typography>
                            <Typography component="p">
                                Fend off the enemy and conquer hostile worlds
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography component="h5" variant="h5">
                                Starships
                            </Typography>
                            <Typography component="p">
                                Build and rank up starships to engage the enemy
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography component="h5" variant="h5">
                                Satellites
                            </Typography>
                            <Typography component="p">
                                Construct satellites to defend your colonies
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
            {/* 
            <Divider />

            <Container maxWidth={false} className="bg-2" align="center">
                <Box maxWidth="md" sx={{margin: 'auto', p: 10, pb: '0'}}>
                    <Box
                        sx={{
                            mb: 4,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <img
                            src={planet3}
                            className="section-icon"
                            alt="planet"
                        />
                    </Box>
                    <Typography
                        component="h4"
                        variant="h4"
                        color="text.primary"
                        gutterBottom
                        sx={{
                            mb: 8,
                        }}
                    >
                        Coming Soon
                    </Typography>

                    <Grid container spacing={5} wrap="wrap" sx={{mb: 5}}>
                        <Grid item xs={12} md={6}>
                            <Typography component="h5" variant="h5">
                                Unique Ship Classes
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography component="h5" variant="h5">
                                New Weapons
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography component="h5" variant="h5">
                                Additional Opponents
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography component="h5" variant="h5">
                                New Astronomical Objects
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography component="h5" variant="h5">
                                And Much More!
                            </Typography>
                        </Grid>
                    </Grid>
                    <img className="sunrise" src={sunrise} alt="sunrise" />
                </Box>
            </Container> */}
        </>
    )
}

export default Landing
